import { LightbulbRounded } from '@mui/icons-material';
import { Stack, Typography, alpha } from '@mui/material';

export const TenantSelectionViewFooter = () => {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      width={440}
      py={1.5}
      spacing={1}
      borderRadius={2}
      sx={{
        background: (theme) => alpha(theme.palette.text.primary, 0.08),
      }}
    >
      <LightbulbRounded color="disabled" />
      <Typography variant="body2" color="text.secondary">
        TIP: Quickly access a instance by saving the 🔗 link to it
      </Typography>
    </Stack>
  );
};
